import React from 'react';
import { Link } from 'react-router-dom';
import dinoImage from '../../../assets/admin/img/Dino-Land-logo.png';

const WebsiteHome = () => {
  return (
    <div className="bg-info min-vh-100 d-flex justify-content-center align-items-center" style={{ background: "linear-gradient(135deg, #68e1fd 0%, #fbd53d 100%)" }}>
      <div className="card shadow-lg p-4 text-center" style={{ borderRadius: "1.5rem", minWidth: "340px", background: "rgba(255,255,255,0.93)" }}>
        <img
          src={dinoImage}
          alt="Dinosaur"
          className="mx-auto mb-3"
          style={{
            width: "120px",
            animation: "bounce 1.6s infinite",
          }}
        />
        <h1 className="mb-2" style={{
          fontFamily: 'Fredoka One, Comic Sans, Arial, sans-serif',
          color: "#36594C",
          fontWeight: "700",
          letterSpacing: "2px"
        }}>
          Welcome to Dino Land
        </h1>
        <p className="lead mb-4" style={{ color: "#2b4231" }}>
          Explore the world of dinosaurs and learn through fun games!
        </p>
        <Link
          to="/admin"
          className="btn btn-gradient btn-lg px-4 fw-bold mb-4"
          style={{
            background: "linear-gradient(135deg, #fc6767, #ec008c)",
            color: "#fff",
            border: 0,
            transition: "transform 0.2s"
          }}
          onMouseOver={e => { e.currentTarget.style.transform = "scale(1.07)"; }}
          onMouseOut={e => { e.currentTarget.style.transform = "scale(1)"; }}
        >
          Go to Admin Panel
        </Link>

        <div className="mt-2 d-flex flex-wrap justify-content-center gap-3">
          <Link to="/privacy-policy" className="text-decoration-none text-muted small">Privacy Policy</Link>
          <Link to="/terms-and-conditions" className="text-decoration-none text-muted small">Terms & Conditions</Link>
          <Link to="/delete-account" className="text-decoration-none text-muted small">Delete Account</Link>
          <Link to="/contact-us" className="text-decoration-none text-muted small">Contact Us</Link>
        </div>
        <style>{`
          @keyframes bounce {
            0%, 100% { transform: translateY(0);}
            40% { transform: translateY(-20px);}
            60% { transform: translateY(-10px);}
          }
        `}</style>
      </div>
    </div>
  );
};

export default WebsiteHome;
